import {Component} from 'react'
import {Badge, Dropdown, DropdownMenu, DropdownToggle, ListGroup} from 'reactstrap'
import {Link} from 'react-router-dom'
import connect from 'react-redux/lib/connect/connect'

import Notification from './components/Notification.jsx'

import api from '../../../api.js'
import {generate} from '../../routes.js'

import logo from '../../../public/static/icons/ui_icon_bell.svg'

import './Notifications.scss'

function createNotificationsList(notifications, loadNotifications) {
  if (notifications) {
    return notifications.map((item) => {
      return (
        <Notification
          key={`notification-${item.id}`}
          notification={item}
          loadNotification={loadNotifications}
        />
      )
    })
  }
  return <span/>
}

class Notifications extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dropdownOpened: false,
      countUnacknowledged: 0,
      notifications: false,
    }
  }

  toggle = () => {
    if (!this.state.dropdownOpened && this.state.countUnacknowledged && this.props.currentUniverseId !== null) {
      api.notifications.acknowledge({universe: this.props.currentUniverseId})
      this.setState({countUnacknowledged: 0})
    }
    this.setState({
      dropdownOpened: !this.state.dropdownOpened,
    })
  }

  loadNotification = async () => {
    if (this.props.currentUniverseId !== null) {
      const response = (await api.notifications.getMy({universe: this.props.currentUniverseId})).data
      const notifications = response.items
      const countUnack = response.count
      this.setState({notifications: notifications.slice(0, 10), countUnacknowledged: countUnack})
    }
  }

  markAsSeen = async () => {
    api.notifications.markAsSeen({universe: this.props.currentUniverseId})
    await this.loadNotification()
  }


  componentDidMount() {
    if (!this.state.notifications) {
      this.loadNotification()
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (prevProps.currentUniverseId !== this.props.currentUniverseId) {
      this.loadNotification()
    }
  }

  render() {
    return (
      <Dropdown
        isOpen={this.state.dropdownOpened}
        toggle={this.toggle}
        className="p-0 notifications-dropdown align-self-center"
      >
        <DropdownToggle className="notifications-toggle">
          <img src={logo} alt={`notifications logo`}/>

          <Badge
            className="notifications-badge"
            color={this.state.countUnacknowledged ? 'danger' : 'danger'}
            pill>
            {this.state.countUnacknowledged}
          </Badge>
        </DropdownToggle>

        <DropdownMenu right className="p-0 notifications-menu">
          <ListGroup className="p-0 notifications-list">
            {createNotificationsList(this.state.notifications, this.loadNotification)}

            <p onClick={this.markAsSeen} className="text-action">
              Tout marquer comme lu
            </p>

            <Link to={generate({name: 'notifications'})} className="text-action">
              Voir toutes les notifications
            </Link>
          </ListGroup>
        </DropdownMenu>
      </Dropdown>
    )
  }
}

export default connect(
  state => ({
    currentUniverseId: state?.universe?.currentUniverse?.id ?? null
  }),
)(Notifications)
